var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-wrapper"}},[_c('div',{attrs:{"id":"loading-text"}},[_vm._v("LOADING")]),_c('div',{attrs:{"id":"loading-content"}})])}]

export { render, staticRenderFns }